module.exports = function() {
    this._sendMessage('close')
};